import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateTipoMonedaRequest } from '@models/tipoMoneda/createTipoMonedaRequest.model';
import { UpdateTipoMonedaRequest } from '@models/tipoMoneda/updateTipoMonedaRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class TipoMonedaService {


  constructor(private http:HttpClient) {
  }

  create(createTipoMonedaRequest:CreateTipoMonedaRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/TipoMoneda/Create",createTipoMonedaRequest);
  }

  update(updateTipoMonedaRequest:UpdateTipoMonedaRequest):Observable<any>
  {
    return  this.http.put<any>("/api/TipoMoneda/Update",updateTipoMonedaRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/TipoMoneda/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/TipoMoneda/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/TipoMovimiento/Delete?id=" + id);
    else
      return of(null)
  }
}
